import { TutorialBenchmarkStepConfig } from '@scale/shared/onboardingControlPanel/index';
import { OutlineSection } from 'react-scale/remotasks.com/components/Expert/OutlinePanel';
import { OutlineSectionV2 } from 'react-scale/remotasks.com/components/Expert/OutlinePanel/OutlineSectionV2';
import { OutlineSectionTitleAdornment } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/components/OutlineSectionTitleAdornment';
import {
  useGetOutlineNodeStatus,
  useProjectOutlineStore,
} from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/stores/projectOutlineStore';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';
import { useUser } from 'react-scale/components/ui/UserContext';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';

type TutorialBenchmarkSectionProps = {
  node: TutorialBenchmarkStepConfig;
};
export const TutorialBenchmarkSection = ({ node }: TutorialBenchmarkSectionProps) => {
  const user = useUser();
  const useNewMpView = useUnleashFeatureFlag('mp-nav-change', { userId: user._id }, true);
  const { status, selected } = useGetOutlineNodeStatus(node);
  const assessmentPayRate = useProjectOutlineStore(state => state.assessmentPayRate);

  return useNewMpView ? (
    <OutlineSectionV2
      title={'Practice example'}
      steps={[]}
      active={selected}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={
        <OutlineSectionTitleAdornment status={status} payRate={assessmentPayRate} />
      }
    />
  ) : (
    <OutlineSection
      title={'Practice example'}
      steps={[]}
      active={selected}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={
        <OutlineSectionTitleAdornment status={status} payRate={assessmentPayRate} />
      }
    />
  );
};
